export default "__VITE_ASSET__CxZtXadQ__"